export const selectAnnouncements = state => state.announcements;
export const selectAnnouncement = state => state.announcement;
export const selectImages = state => state.images;
export const selectImage = state => state.image;
export const selectLoading = state => state.loading;
export const selectNotification = state => state.notification;
export const selectShowNotification = state => state.showNotification;
